<template>
    <section class="main" style="position: relative" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">
        <v-container>
            <v-row>
                <v-col cols="12" class="main"  >
                    <div class="iframe-container">
                        <iframe :width="size.width" :height="size.height" :src="'https://www.youtube.com/embed/' + rightLink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>

                        </iframe>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </section>
</template>

<script>

    export default {
        props:["block"],
        name: "YoutubeBlock",
        data(){
            return{
                videoInput: false,
            }
        },
        computed: {
            rightLink(){
                var kek = this.block.url.slice(32)
                return kek
            },
            size() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return {
                        width: 250,
                        height: 130
                    }
                    case 'sm': return {
                        width: 300,
                        height: 160
                    }
                    case 'md':
                        return {
                            width: 560,
                            height: 315
                        }
                    case 'lg':
                        return {
                            width: 1000,
                            height: 500
                        }
                    case 'xl':
                        return {
                            width: 1000,
                            height: 500
                        }
                }
                return false
            }
        },



    }
</script>

<style scoped>
    .main{
        position: relative;
    }

    .iframe-container{
        margin: 0 auto;
        width: fit-content;
    }

    .color-picker-closer{
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
    }

    .color-picker{
        position: absolute;
        z-index: 100;
        bottom: 0;
        right: 0
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

</style>